import { Injectable } from "@angular/core";
import { GlobalApiService, GlobalConstantsWebservice, GlobalFunctions, GlobalSessionData } from "globales-projekt-angular";
import { GebKlasse } from "../data/ws/dbKlassen/geb-klasse.model";
import { Observable, catchError, map, retry } from "rxjs";
import { ConstantsWebservice } from "../immutable/constants-webservice";
import { Tierkategorie } from "../data/ws/dbKlassen/tierkategorie.model";
//import { Modul } from "../data/ws/modul/modul.model";
import { UserGebaeudeFilter } from "../data/user/user-gebaeude-filter.model";
import { Gebaeude } from "../data/ws/dbKlassen/gebaeude.model";
import { Preisstand } from "../data/ws/dbKlassen/preisstand.model";
import { ModulAuspraegungPrFilter } from "../data/ws/modul/modul-auspraegung-pr-filter.model";
import { Ergebnisse } from "../data/ws/ergebnis/ergebnisse.model";
import { UserAuswahlGebaeude } from "../data/user/user-auswahl-gebaeude.model";
import { Kge } from "../data/ws/dbKlassen/kge.model";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: 'root',
})

export class ApiService extends GlobalApiService {

  getGebklassen(): Observable<GebKlasse[]> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_GEBKLASSE;
    return this.http
      .get<GebKlasse[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getPreisstaende(): Observable<Preisstand[]> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_PREISSTAENDE;
    return this.http
      .get<Preisstand[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getIstGebaeude(idGebaeude: number): Observable<number | null> {
    const paramsObject = { idGebaeude };
    const serviceUrl = GlobalSessionData.baseUrl + ConstantsWebservice.GET_IST_GEBAEUDE;

    return this.http
      .get<number | null>(serviceUrl, {
        params: new HttpParams({ fromObject: paramsObject })
      })
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        map((value: number | null | undefined) => value ?? null),
        catchError(GlobalFunctions.handleError)
      );
  }

  getTierkategorien(): Observable<Tierkategorie[]> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_TIERKATEGORIEN;
    return this.http
      .get<Tierkategorie[]>(serviceUrl)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postGebaeudeUebersicht(body: number): Observable<Gebaeude[]> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_GEBAEUDE_UEBERSICHT;
    return this.http
      .post<Gebaeude[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postModAuspPrFilter(body: UserGebaeudeFilter): Observable<ModulAuspraegungPrFilter> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_MOD_AUSP_FILTER;
    return this.http
      .post<ModulAuspraegungPrFilter>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postErgebnisse(body: UserAuswahlGebaeude): Observable<Ergebnisse> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + GlobalConstantsWebservice.POST_WS_ERGEBNISSE;
    return this.http
      .post<Ergebnisse>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postKge(body: number[]): Observable<Kge[]> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.POST_KGE;
    return this.http
      .post<Kge[]>(serviceUrl, body)
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  getGebaeudeDatei(idDatei: number): Observable<Blob> {
    const paramsObject: any = { idDatei: idDatei };
    const serviceUrl: string =
      GlobalSessionData.baseUrl + ConstantsWebservice.GET_GEBAEUDE_DATEI;
    return this.http
      .get<Blob>(serviceUrl, {
        params: new HttpParams({ fromObject: paramsObject }),
        responseType: 'blob' as 'json',
      })
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

  postDownloadExcel(body: UserAuswahlGebaeude): Observable<Blob> {
    const serviceUrl: string =
      GlobalSessionData.baseUrl + GlobalConstantsWebservice.POST_ERGEBNISSE_EXCEL;

    return this.http
      .post<Blob>(
        serviceUrl,
        body,
        GlobalConstantsWebservice.RESPONSETYPE_BLOB_JSON
      )
      .pipe(
        retry(GlobalConstantsWebservice.RETRY_VERSUCHE),
        catchError(GlobalFunctions.handleError)
      );
  }

}